var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorderBackground7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 595.28 841.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "File KhungVien-04b") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7805",
    d: "M579.64,826.95h-564v-812h564V826.95z M16.61,825.97h562.06v-810H16.65L16.61,825.97z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderBackground7);
export default __webpack_public_path__ + "static/media/borderBackground7.0e5f94653f232b563f1e9c5b82c63485.svg";
export { ForwardRef as ReactComponent };